import React, { createContext, useContext } from "react";

type InternalHeaderContextType = {
  setLeftContent: (content: React.ReactNode) => void;
  setTitleContent: (content: React.ReactNode) => void;
};

export const InternalHeaderContext = createContext<InternalHeaderContextType>({
  setLeftContent: () => {},
  setTitleContent: () => {},
});

export const useInternalHeader = () => useContext(InternalHeaderContext);
